module.exports = __webpack_public_path__ + "static/media/steve-guitars.4967de71.jpg";